import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import Columns from "./components/Columns";
import NewsFeed from "./components/NewsFeed";
import Join from "./components/Join";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <HotTopics />
        <Columns />
        <NewsFeed />
        <Join />
        <Faq />
      </main>
      <Footer />

      {/* 回到顶部 */}
      {showTop && (
        <button
          aria-label="回到顶部"
          onClick={backToTop}
          className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-xl text-white shadow-md transition hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line" />
        </button>
      )}
    </div>
  );
}